import { render, staticRenderFns } from "./adDisplayPageComponentNews.vue?vue&type=template&id=e475ae9c&scoped=true&"
import script from "./adDisplayPageComponentNews.vue?vue&type=script&lang=js&"
export * from "./adDisplayPageComponentNews.vue?vue&type=script&lang=js&"
import style0 from "./adDisplayPageComponentNews.vue?vue&type=style&index=0&id=e475ae9c&prod&lang=css&"
import style1 from "./adDisplayPageComponentNews.vue?vue&type=style&index=1&id=e475ae9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e475ae9c",
  null
  
)

export default component.exports